module.exports = __webpack_public_path__ + "static/media/tiger-800.c3de6ec1.jpg";